// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"db961a15","100":"3ca635f0","106":"30bcb736","341":"9f1499d4","554":"a52b3415","716":"13940c4f","729":"8029e364","825":"537c663b","849":"e22b0b11","873":"f90c0d0b","988":"22fbe71c","993":"d2b97ec1"}[chunkId] + ".chunk.js";
};